import Component from '../Component';
import Crop from '../../Prototype/World/Crop';
import { Random } from '../../Utility/Random';
import Game from '../../Game';
import { TimerType } from '../../System/Timer/TimerTypes';
import { IGameState } from '../../State/Game/IGameState';
import Sign from '../../Prototype/World/Sign';
import {
    GrowthStage,
    ICropSettings,
    IHarvestSettings,
} from '../../State/World/IFieldData';
import { SectorLockData } from '../../Prototype/World/Field';

export default class FieldComponent extends Component {
    // Field Data
    public id: string = undefined;

    public locked: boolean = true;
    public requiredLevel: number[] = undefined;
    public sectors: Map<number, Crop[]> = new Map<number, Crop[]>();

    public currentStage: GrowthStage = undefined;
    public growthStages: {
        [key in GrowthStage]: Random.IWeightedItem<string>[];
    } = {
        [GrowthStage.LOCKED]: [],
        [GrowthStage.READY]: [],
        [GrowthStage.HARVESTED]: [],
        [GrowthStage.GROWING]: [],
    };

    // Sign Data
    public signs: Sign[] = undefined;

    // Crop Data
    public crops: Crop[] = [];
    public harvestSettings: IHarvestSettings = undefined;
    public cropSettings: ICropSettings = undefined;
    public sectorLockData: SectorLockData = undefined;

    public getGrowthStage(
        state: IGameState = Game.store.getState()
    ): GrowthStage {
        const harvestTime: Date = state.playerState.timers.get(
            TimerType.HARVEST
        );

        if (this.locked) {
            return GrowthStage.LOCKED;
        } else if (harvestTime !== null) {
            return GrowthStage.GROWING;
        } else {
            return GrowthStage.READY;
        }
    }
    public isSectorLocked(
        state: IGameState = Game.store.getState(),
        sectorID?: number
    ): boolean {
        const highestLevel: number = Game.player.getHighestLevelCompleted(
            state
        );

        if (sectorID !== undefined) {
            return highestLevel < this.requiredLevel[sectorID];
        } else {
            return this.requiredLevel.some(
                (levelRequirement: number) => highestLevel < levelRequirement
            );
        }
    }
    public addToSector(crop: Crop, sectorID: number): void {
        if (!this.sectors.has(sectorID)) {
            this.sectors.set(sectorID, [crop]);
        } else {
            this.sectors.get(sectorID).push(crop);
        }
    }
}

